import { ajax } from 'discourse/lib/ajax';
import DiscourseRoute from 'discourse/routes/discourse';

export default class ProxyviewsAffiliateDisclosureRoute extends DiscourseRoute {
  async model() {
    return await ajax('/affiliate-disclosure.json');
  }

  titleToken() {
    return 'Affiliate Disclosure';
  }
}
